import { Dialog, withStyles } from "@material-ui/core";
import React from "react";
import { withTranslation } from "react-i18next";
import styles from "../../../../styles/common/DialogStyles.module.scss";
import CloseButton from "../../../../shared/Close";
const StyledDialog = withStyles({
  paper: {
    width: 700,
    maxWidth: 700,
  },
})(Dialog);
const SpecsDialog = (props) => {
  return (
    <StyledDialog open={props.open} onClose={props.onClose}>
      <div className={styles.dialogWrapper}>
        <button className={styles.close} onClick={props.onClose}>
          <CloseButton />
        </button>
        <div className={styles.dialogTitle}>
          {props.t("CustomerReservations.specs")}
        </div>
        <div className={styles.dialogDescription}>
          {props.specs.map((spec, index) => {
            return (
              <div
                className={index % 2 === 1 ? styles.rowHighlight : styles.row}
              >
                {spec}
              </div>
            );
          })}
        </div>
      </div>
    </StyledDialog>
  );
};

export default withTranslation("emp")(SpecsDialog);
